import { useState } from "react";
import { useGetSalesName } from "../sales/useGetSalesName";
import type { BCInteractionLog } from "../types";
import { RelativeDate } from "../misc/RelativeDate";
import { BCInteractionDeepLink } from "./BCInteractionDeepLink";

export const BCInteractionEntryMobile = ({
  interaction,
}: {
  interaction: BCInteractionLog;
}) => {
  const [expanded, setExpanded] = useState(false);
  const salesName = useGetSalesName(interaction.salesperson_id, {
    enabled: !!interaction.salesperson_id,
  });

  return (
    <div
      className="py-3 active:bg-accent/50 -mx-2 px-2 rounded-md cursor-pointer"
      onClick={() => setExpanded((v) => !v)}
    >
      <div className="flex items-center gap-2">
        <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 border border-slate-200 shrink-0 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700">
          BC
        </span>
        <span className="text-sm flex-1 line-clamp-1">
          {interaction.description || interaction.interaction_template_code}
        </span>
        <div className="flex items-center gap-1.5 shrink-0">
          <BCInteractionDeepLink
            interaction={interaction}
            className="text-muted-foreground hover:text-foreground p-1 -m-1"
            onClick={(event) => event.stopPropagation()}
          />
          <span className="text-xs text-muted-foreground">
            <RelativeDate date={interaction.interaction_date} />
          </span>
        </div>
      </div>
      {expanded && (
        <div className="mt-1 pl-6 text-xs text-muted-foreground space-y-0.5">
          {interaction.interaction_template_code && (
            <p>{interaction.interaction_template_code}</p>
          )}
          {interaction.document_no && (
            <p>
              {interaction.document_type} {interaction.document_no}
            </p>
          )}
          {salesName && <p>{salesName}</p>}
        </div>
      )}
    </div>
  );
};
